import React from 'react';
import { Await } from '../../../components/Await';
import { BlogSection as RawBlogSection } from '../../../components/landingPage/BlogSection';
import { SanityObject, useSanity } from '../../../lib/landingPage';
import { ButtonLink, ButtonLinkProps } from '../Link';
import { Wrapper } from '../Wrapper';
import { BlogPostPreview } from '../BlogPostPreview';
import { observer } from 'mobx-react-lite';

export type BlogSectionProps = {
    query: string;
    caption: string;
    link: SanityObject<ButtonLinkProps>;
};

export const BlogSection = Wrapper(
    observer(({ caption, query, link }: BlogSectionProps): JSX.Element => {
        const sanity = useSanity();
        return (
            <RawBlogSection
                caption={caption}
                link={<ButtonLink value={link} />}>
                <Await
                    views={{ value: sanity.asyncBlog(query) }}
                    resolved={BlogPostPreview}
                />
            </RawBlogSection>
        );
    }),
    'blogSection'
);
